// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Contextual sign-up nudge ---
   Reuses the .modal-overlay / .login-modal shell and .login-btn styles from the global
   stylesheet. Only the nudge-specific layout lives here. */

.signup-nudge {
  max-width: 24rem;
  text-align: center;
}

.signup-nudge__title {
  margin: 0 0 0.5rem;
  font-size: 1.25rem;
  line-height: 1.2;
}

.signup-nudge__message {
  margin: 0 0 1.25rem;
  opacity: 0.85;
  line-height: 1.4;
}

.signup-nudge__actions {
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
}

.signup-nudge__cta {
  width: 100%;
  font-size: 1.05rem;
  padding: 0.75rem 1rem;
}

.signup-nudge__reassure {
  margin: 0;
  font-size: 0.85rem;
  opacity: 0.7;
}

.signup-nudge__later {
  margin-top: 0.25rem;
  background: none;
  border: none;
  padding: 0.25rem;
  color: inherit;
  opacity: 0.65;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
}

.signup-nudge__later:hover {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/signup-nudge/signup-nudge.css"],"names":[],"mappings":"AAAA;;2DAE2D;;AAE3D;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* --- Contextual sign-up nudge ---\r\n   Reuses the .modal-overlay / .login-modal shell and .login-btn styles from the global\r\n   stylesheet. Only the nudge-specific layout lives here. */\r\n\r\n.signup-nudge {\r\n  max-width: 24rem;\r\n  text-align: center;\r\n}\r\n\r\n.signup-nudge__title {\r\n  margin: 0 0 0.5rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.signup-nudge__message {\r\n  margin: 0 0 1.25rem;\r\n  opacity: 0.85;\r\n  line-height: 1.4;\r\n}\r\n\r\n.signup-nudge__actions {\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.signup-nudge__cta {\r\n  width: 100%;\r\n  font-size: 1.05rem;\r\n  padding: 0.75rem 1rem;\r\n}\r\n\r\n.signup-nudge__reassure {\r\n  margin: 0;\r\n  font-size: 0.85rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n.signup-nudge__later {\r\n  margin-top: 0.25rem;\r\n  background: none;\r\n  border: none;\r\n  padding: 0.25rem;\r\n  color: inherit;\r\n  opacity: 0.65;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  text-decoration: underline;\r\n}\r\n\r\n.signup-nudge__later:hover {\r\n  opacity: 0.9;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
